/**
 * context/devFlags.ts
 * Dev-only feature flags. The persona/entitlement switcher is a build + QA aid
 * for previewing every surface without real logins; it must NEVER appear in
 * product chrome. Gated on the webpack `mode` (development) and an optional
 * localStorage override so it can be force-disabled even in dev.
 */

import { Platform } from 'react-native';

declare const process: { env?: { NODE_ENV?: string } };

// Read NODE_ENV in a way every bundler can statically replace. Webpack's
// DefinePlugin (mode: development/production) substitutes the literal
// `process.env.NODE_ENV` text, so we must reference it directly — NOT behind a
// `typeof process` runtime guard (webpack doesn't define `process` as a global,
// so that guard would wrongly read undefined and disable dev tools). The
// try/catch covers any runtime where the reference itself throws.
function readNodeEnv(): string | undefined {
  try {
    return process.env?.NODE_ENV;
  } catch {
    return undefined;
  }
}

/** True in any non-production build, unless explicitly turned off in localStorage. */
export const DEV_TOOLS_ENABLED: boolean = (() => {
  if (readNodeEnv() === 'production') return false;
  if (Platform.OS === 'web' && typeof window !== 'undefined') {
    try {
      if (window.localStorage.getItem('skq.devtools') === 'off') return false;
    } catch {
      /* ignore */
    }
  }
  return true;
})();
